<template>
  <el-card class="office-balance-card">
    <div slot="header" class="clearfix detail-header">
      <span>{{ headerText }} Balance</span>
      <el-button type="primary" icon="fa fa-download" @click="makeDepositDialogVisible = true">Make Deposit</el-button>
    </div>
    <h2 :class="balanceClasses" v-loading="isLoading">
      {{ balance !== null ? `$${balance}` : '' }}
    </h2>
    <el-dialog title="Make Deposit" :visible.sync="makeDepositDialogVisible" :close-on-click-modal="false" width="350px">
      <make-deposit-dialog @close="makeDepositDialogVisible = false" :office-id="officeId" :type-id="typeId" @depositSubmitted="onDepositSubmitted"></make-deposit-dialog>
    </el-dialog>
  </el-card>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '@/api';
import { TRANSACTION_TYPE_DESCRIPTION_MAP } from '@/enum/TransactionType';
import { DEPARTMENT } from '@/enum/UserDepartments';
import MakeDepositDialog from '@/components/dialog-content/MakeDeposit.vue';

export default {
  props: {
    typeId: {
      type: Number,
      default: undefined,
    },
    officeId: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      isLoading: false,
      makeDepositDialogVisible: false,
      balance: null,
    };
  },
  methods: {
    updateBalance() {
      if (this.officeId !== undefined && this.typeId !== undefined) {
        this.isLoading = true;
        api.transaction.officeBalance(this.officeId, this.typeId).then((response) => {
          this.balance = response.data || 0;
        }).finally(() => {
          this.isLoading = false;
        });
      }
    },
    onDepositSubmitted() {
      this.updateBalance();
    },
  },
  computed: {
    ...mapGetters('User', [
      'user',
      'isAdmin',
    ]),
    isAdminOrAccountant() {
      return this.isAdmin || this.user.departmentId === DEPARTMENT.ACCOUNTANT;
    },
    headerText() {
      return TRANSACTION_TYPE_DESCRIPTION_MAP[this.typeId];
    },
    balanceClasses() {
      const base = ['balance', 'align-center'];
      if (this.balance <= 0) {
        base.push('danger');
      } else if (this.balance <= 300) {
        base.push('warning');
      }
      return base;
    },
  },
  watch: {
    typeId() {
      this.updateBalance();
    },
    officeId() {
      this.updateBalance();
    },
  },
  mounted() {
    this.updateBalance();
  },
  components: {
    MakeDepositDialog,
  },
};

</script>

<style lang="scss" scoped>

.office-balance-card {
  .detail-header {
    font-size: 18px;
    font-weight: bold;
    line-height: 24px;

    button {
      float: right;
      padding: 5px 5px;
    }
  }
  .balance {
    font-size: 3em;
    margin: 0;

    &.danger {
      color: #F56C6C;
    }
    &.warning {
      color: #E6A23C;
    }
  }
}

</style>
